import {
  CdkDragDrop,
  CdkDragMove,
  CdkDragStart,
  CdkDragEnd
} from '@angular/cdk/drag-drop';
import {
  Component,
  OnInit,
  Input,
  TemplateRef,
  OnDestroy,
  AfterViewInit,
  ViewChildren,
  QueryList
} from '@angular/core';
import { DashboardBase } from '../dashboard.base';
import {
  Stop,
  SectorCompress,
  RouteCompress
} from '../../../../@core/models/live-route';
import { RouteStatus } from '../../../../@core/models/dto-routestatus';
import { Subscription } from 'rxjs';
import { LiveRouteType } from '../../../../@core/models/live-route-type';
import { ElementQueries } from 'css-element-queries';
import { LocationModel } from '../../../../@core/models/location';
import { SignatureDialogComponent } from '../../../../@theme/components/signature-dialog/signature-dialog.component';

@Component({
  selector: 'ngx-stop-table',
  templateUrl: './stop-table.component.html',
  styleUrls: ['./stop-table.component.scss']
})
export class StopTableComponent
  extends DashboardBase
  implements OnInit, OnDestroy, AfterViewInit {
  public CurrentDate: Date = new Date();
  @Input()
  tpl: TemplateRef<any>;
  sub: Subscription;
  @ViewChildren('matCheckbox') private matCheckboxes: QueryList<any>;

  ngOnInit() {
    this.sub = this._stopService.loadingInProgress.subscribe((data) => {
      this.shouldShow = data;
    });
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    if (this._stopService.currentStopsValue != null)
      return (
        this._stopService.selectedStops.length ==
        this._stopService.currentStopsValue.StopCount
      );
    else return false;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle($event) {
    let i = 0;
    const matCheckboxes = this.matCheckboxes.toArray();
    for (const stop of this._stopService.currentStopsValue.StopsList) {
      stop.IsSelected = $event.checked;
      matCheckboxes[i].checked = $event.checked;
      i++;
    }
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: Stop): string {
    return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
  }

  ngAfterViewInit() {
    ElementQueries.listen();
    ElementQueries.init();
  }

  get liverouteType() {
    return LiveRouteType;
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  public displayedColumns: string[] = [
    'IsSelected',
    'StatusIcon',
    'SNR',
    'No_Stop',
    'ExpDate',
    'Priority',
    'Address.Postal_Code',
    'TotalParcel',
    'CustomerName',
    'Lr_Name',
    'Address.Address1',
    'Note',
    'ETA',
    'Forecasted_Arrival_Time',
    'Arrival_Time',
    'Address.City',
    'Consol_ID',
    'Total_COD_Amount'
  ];

  public onDragStart(event: CdkDragStart<string[]>) {
    this.draggingList = true;
  }

  public onDragEnded(event: CdkDragEnd<string[]>) {
    this.draggingList = false;
  }

  zoomToMap(stop: Stop) {
    const location: any = {
      Latitude: stop.Address.Latitude,
      Longitude: stop.Address.Longitude,
      zoom: 16
    };
    this._locationService.setLocation(location);
  }

  updateCheckbox(event: any, Consol_ID: number) {
    this._stopService.GetStop(Consol_ID).IsSelected = event.checked;
  }

  public GetSignaturePhotos(ParcelID: number) {
    this._parcelhistoryService.initialiseParcel(ParcelID);
    this._photoService.getPhotos(ParcelID);
    const dialogRef = this.dialog.open(SignatureDialogComponent, {
      height: '500px',
      width: '800px',
      data: { parcelId: ParcelID }
    });
  }

  checkMultiple(event: MouseEvent, Consol_ID: number) {
    event.stopPropagation();
    let i = 0;
    const matCheckboxes = this.matCheckboxes.toArray();
    if (event.shiftKey) {
      let startSelecting = false;
      let stopLoop = false;
      this._stopService.GetStop(Consol_ID).IsSelected = true;
      for (const stop of this._stopService.currentStopsValue.StopsList) {
        if (stopLoop === false) {
          if (stop.IsSelected) {
            startSelecting = true;
          }
          if (stop.Consol_ID === Consol_ID) {
            startSelecting = false;
            stopLoop = true;
          }
          if (startSelecting) {
            this._stopService.GetStop(stop.Consol_ID).IsSelected = true;
            matCheckboxes[i].checked = true;
          }
        }
        i++;
      }
    }
  }

  getStatus(routeStatus: RouteStatus, stop: Stop): string {
    let _routeStatus = routeStatus.RouteStatus;
    const _minRouteStatus = stop.Min_Live_Route_Status;
    const _maxRouteStatus = stop.Max_Live_Route_Status;
    const Sectors: SectorCompress = this._sectorService.currentSectorValue;
    let _stopStatus: string = '000';
    let _cssclass: string = 'received';

    if (Sectors) {
      for (const oneroute of Sectors.RouteCompress) {
        if (oneroute.Route_ID === stop.Route_ID) {
          _routeStatus = String(oneroute.LiveRouteStatus);
          break;
        }
      }
    }

    _stopStatus = `0${String(_minRouteStatus)}${String(_minRouteStatus)}`;

    switch (_stopStatus) {
      case '000': {
        _cssclass = 'received';
        break;
      }
      case '001': {
        _cssclass = 'intransit';
        break;
      }
      case '011': {
        _cssclass = 'intransit';
        break;
      }
      case '111': {
        _cssclass = 'inroute';
        break;
      }
      case '022': {
        _cssclass = 'inroute';
        break;
      }
      case '033': {
        _cssclass = 'failed';
        break;
      }
      case '044': {
        _cssclass = 'shipped';
        break;
      }
      case '444': {
        _cssclass = 'shipped';
        break;
      }
      case '422': {
        _cssclass = 'inroute';
        break;
      }
      case '433': {
        _cssclass = 'failed';
        break;
      }
      default: {
        _cssclass = 'received';
        break;
      }
    }

    return _cssclass;
  }
}
